var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"selectIndex":1}},[_c('carousel'),_c('overview-one'),_c('overview-two'),_c('overview-four'),_c('overview-three',{attrs:{"range":1}}),_c('overview-five')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }